import { useMutation, useQueryClient } from '@tanstack/react-query'
import { locationApis } from '../../../gateways/breadstack/locationApis'
import { usePantryStore } from '../../../providers/PantryProvider'
import type { ZoneAreaType } from '../../../types/location'

export interface LocationDetailsPayload {
  name?: string
  phone_number?: string
  address_1?: string
  address_2?: string
  city?: string
  state?: string
  country?: string
  postal_code?: string
  license?: string
  email?: string
  photo_url?: string
  // Location-level delivery-zone variant selection (mirrors warehouse
  // `area_type`). Sent through the same PATCH path the address fields use.
  area_type?: ZoneAreaType
  // Pantry compliance / tax — regulatory minimum age + shipping tax %.
  minimum_legal_age?: number
  shipping_tax_percentage?: string
}

export function useLocationUpdate() {
  const queryClient = useQueryClient()
  const store = usePantryStore()
  const storeId = store?.storeId ?? ''
  const orgId = store?.orgId

  return useMutation({
    mutationFn: ({
      warehouseId,
      data,
    }: { warehouseId: string; data: LocationDetailsPayload }) =>
      locationApis.updateDetails(storeId, warehouseId, data),
    onSuccess: (_result, { warehouseId }) => {
      queryClient.invalidateQueries({
        queryKey: ['warehouses', storeId, orgId],
      })
      queryClient.invalidateQueries({
        queryKey: ['locationDetail', storeId, warehouseId],
      })
    },
  })
}
